import styled from 'styled-components';
import { color } from '../../../../atoms/colors';
import { shadow } from '../../../../atoms/shadows';
import { font } from '../../../../atoms/typography';
import { spacing } from '../../../../atoms/spacing';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${props => props.hidden && `display: none;`}

  .react-tel-input {
    margin-bottom: ${spacing[12]};
  }

  && .phone-input-container {
    width: 100%;
    .form-control {
      width: 100%;
      height: auto;
      padding: 8px 12px 8px 48px;
      margin: ${spacing[0]} ${spacing[0]} ${spacing[12]};
      border-radius: 8px;
      background: ${color.common.white};
      border: 1px solid ${color.darkBlue[100]};
      ${shadow('xs', 'dark')}
      ${font('text', 'md', '400')}
      color: ${color.darkBlue[700]};
      transition: all 250ms ease-in-out;
      &::placeholder {
        ${font('text', 'sm', '400')}
        color: ${color.darkBlue[600]};
      }

      &:focus,
      &:hover {
        box-shadow: none;
      }

      &.error {
        border: 1px solid ${color.primary[1000]};
      }
    }
  }

  .react-tel-input .country-list {
    z-index: 10000;
    .country {
      display: flex;
      .flag {
        position: unset;
      }
    }
  }

  &.control-phone .error-message {
    transform: translateY(7px);
  }

  &.control-phone .error-icon {
    top: 53.5%;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]};

  .special-label {
    display: none !important;
  }
`;

export const Label = styled.label`
  ${font('text', 'sm', '400')}
  color: ${color.darkBlue[700]};
  margin: ${spacing[0]};
`;

export const Astericks = styled.span`
  width: 10px;
  height: 10px;
  ${font('text', 'sm', '700')}
  color: ${color.darkBlue[700]};
`;

export const Input = styled.input`
  && {
    width: 100%;
    height: auto;
    padding: 8px 12px;
    margin: ${spacing[0]} ${spacing[0]} ${spacing[12]};
    border-radius: 8px;
    background: ${color.common.white};
    border: 1px solid ${color.darkBlue[100]};
    ${shadow('xs', 'dark')}
    ${font('text', 'md', '400')}
    color: ${color.darkBlue[700]};
    transition: all 250ms ease-in-out;

    &::placeholder {
      ${font('text', 'sm', '400')}
      color: ${color.darkBlue[600]};
    }

    &:focus,
    &:hover {
      box-shadow: none;
    }

    &.error {
      border: 1px solid ${color.primary[1000]};
    }
  }
`;

export const ErrorIcon = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 42.5%;
  right: 12px;
`;

export const ErrorMessage = styled.div`
  transform: translateY(-12px);
  ${font('text', 'sm', '400')}
  color: ${color.primary[1000]};
  p {
    ${font('text', 'sm', '400')}
    color: ${color.primary[1000]};
  }
  a {
    ${font('text', 'sm', '400')}
    color: ${color.blue[700]};
  }
`;

export const SelectStyles = {
  container: baseStyles => ({
    ...baseStyles,
    marginBottom: '0.75rem',
  }),
  placeholder: baseStyles => ({
    ...baseStyles,
    color: color.darkBlue[600],
    fontSize: '0.875rem',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused ? color.grey[100] : 'white',
    color: state.isFocused ? color.grey[900] : color.grey[700],
    cursor: 'pointer',
    padding: '8px 12px',
    '&:hover': {
      backgroundColor: color.grey[100],
      color: color.grey[900],
    },
  }),
};
